/* ============================================================
   STATIC CHANNEL LINEUP — the built-in fallback.
   ------------------------------------------------------------
   Used when the Netlify data service is unreachable (offline,
   local dev without data, cold deploy before the first cron run).
   Everything goes through the canonical schema's parseChannels, so
   the fallback is the exact same shape as remote + user channels.
   ============================================================ */
import { parseChannels, type Channel } from '@/schema/channel'
import seed from './seed-config.json'

/** The built-in lineup, validated + normalized through the canonical schema. */
export const CHANNELS: Channel[] = parseChannels(seed, 'builtin')
